<template>
  <div class="holder" ref="xxx">
    <div class="bkg animated zoomIn"
         :style="`background-image: url(${bkgUrl}); background-position: ${position}`"
         :class="{show: imageReady}"></div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import isRetina from 'is-retina';
import throttle from 'lodash.throttle';
import replace from 'lodash.replace';

export default {
  name: 'Bkg',
  props: {
    url: {
      required: true,
      default: 0,
    },
    position: {
      required: false,
      default: 'center center',
    },
  },
  data() {
    return {
      imageReady: false,
      currentSize: 0,
      bkgUrl: '',
      containerWidth: 1,
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.url) {
        this.containerWidth = this.getContainerWidth();
        if (this.containerWidth) this.handleImage();
      }
    });
    window.addEventListener('resize', throttle(() => {
      if (this.url) {
        this.containerWidth = this.getContainerWidth();
        if (this.containerWidth && this.containerWidth > this.currentSize) {
          this.handleImage();
        }
      }
    }, 400));
  },
  methods: {
    handleImage() {
      this.containerWidth = this.getContainerWidth();
      const img = new Image();
      const that = this;
      img.onload = (i) => {
        try {
          this.containerWidth = this.getContainerWidth();
          that.bkgUrl = i.target.src;
          that.imageReady = true;
        } catch (e) {
          this.$log.error(e);
        }
      };
      img.onerror = (e) => {
        this.$log.error(e);
      };
      img.src = this.computedUrl();
      this.computedUrl();
    },
    computedUrl() {
      let w = this.containerWidth;
      if (isRetina()) w *= 2;
      w = this.getImageSize(w);
      return replace(this.url, '{$width}', w);
    },
    getContainerWidth() {
      return this.$refs.xxx ? this.$refs.xxx.offsetWidth : false;
    },
  },
  computed: {
    ...mapGetters(['getImageSize']),
  },
};
</script>
<style lang="scss" scoped>
.holder {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
  z-index: 50;

  .bkg {
    transition: opacity .5s ease;
    display: none;
    width: 100%;
    height: 100%;
    background-size: cover;

    &.show {
      display: block;
    }
  }
}
</style>
